import { FC } from "react";

const Error500: FC = () => {
  return (
    <>
      <div className="mt-6 text-[56px] font-bold leading-none text-action">
        500
      </div>
      <h1 className="mt-3 text-2xl font-semibold text-slate-900">
        A apărut o eroare
      </h1>
      <p className="mt-3 text-sm leading-6 text-muted-dark">
        Încearcă din nou peste câteva momente.
      </p>
    </>
  );
};

export { Error500 };
